import React from "react";
import styled from "styled-components";
import { ClockCircleOutlined } from "@ant-design/icons";
import { SbEmpty } from "uiCore";

const WrapperStyled = styled.div`
  padding: 16px 24px;
`;

const PlaceholderIconStyled = styled.span`
  font-size: 32px;
  color: ${(p) => p.theme?.colors?.textSecondary ?? "#9CA3AF"};
`;

// Not connected to a real backend yet (Strategic Data Store ingestion is
// v1.5/v2.0 scope) — an honest "coming soon" placeholder instead of a
// working-looking upload flow that only stores files locally in the browser.
const OrgContextTab = () => (
  <WrapperStyled>
    <SbEmpty
      image={<PlaceholderIconStyled><ClockCircleOutlined /></PlaceholderIconStyled>}
      description="Coming soon — upload strategy docs and prior reorg notes here for AI Evaluation to reference, once Strategic Data Store ingestion is connected."
    />
  </WrapperStyled>
);

export default OrgContextTab;
